<template>
  <div>
    <NavigationBar
      titel="Sicherheit"
      :tabs="tabs"
      :activeTab="activeTab"
    ></NavigationBar>

    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";

export default {
  name: "admin-security",
  components: {
    NavigationBar,
  },
  data() {
    return {
      activeTab: `security/general`,
      tabs: [
        { id: 1, name: "Allgemein", route: `general` },
        { id: 2, name: "Rollen", route: `roles` },
        { id: 3, name: "Zuordnungsmatrix", route: `matrix` },
        { id: 4, name: "API-Schlüssel", route: `api` },
      ],
    };
  },
};
</script>

<style>
/* .v-tabs-items {
  background-color: transparent !important;
} */
</style>
